import * as React from "react";
import { HBox, VBox } from "framework/structural_components/hbox_vbox";
import { Link } from "framework/link/link";
import { cls_link_default_no_underline } from "framework/link/link.css";
import * as CollapsiblePrimitive from '@radix-ui/react-collapsible';
import { useLocation } from "wouter";
var Collapsible = CollapsiblePrimitive.Root;
var CollapsibleTrigger = CollapsiblePrimitive.Trigger;
var CollapsibleContent = CollapsiblePrimitive.Content;
import { cls_menu_box, cls_menu_item_box, cls_menu_item_divider, cls_menu_item_text, cls_menu_subitem_text, cls_menu_icon_box, cls_menu_gap, cls_menu_selected_subitem, cls_submenu_icon_box, cls_selected_subitem_icon_box, cls_menu_item_container, cls_menu_item_divider_container, cls_menu_box_mobile, cls_menu_or_content_box_mobile_hidden, } from "./menu.css";
import { cls_colorCyan70, cls_gap_rem, cls_h9, cls_p5r } from "style/index.css";
import { useif } from "framework/state/types";
import { useResponsivity } from "framework/responsivity/store";
var MenuItem = function (props) {
    var _a = useResponsivity(), actions = _a[1];
    var style_img = props.icon ? { backgroundImage: "url(".concat(props.icon, ")") } : {};
    var link_content = React.createElement(HBox, { className: [cls_gap_rem, cls_menu_item_box] },
        React.createElement("div", { className: cls_menu_icon_box, style: style_img }),
        React.createElement(HBox, { className: [cls_h9, cls_menu_item_text, useif(props.selected, cls_colorCyan70)] }, props.text));
    return React.createElement(HBox, { className: cls_menu_item_container }, props.url ? React.createElement(Link, { url: props.url, className: cls_link_default_no_underline, routesOutOfThisWeb: props.routesOutOfThisWeb, onClickIfLocal: actions.hideMenu }, link_content) : React.createElement(HBox, { className: cls_link_default_no_underline }, link_content));
};
var MenuSubItem = function (props) {
    var _a = useResponsivity(), actions = _a[1];
    var location = useLocation()[0];
    var url = props.url.split('../').slice(-1)[0];
    var selected = url && location.includes(url);
    var link_content = React.createElement(HBox, { className: [cls_gap_rem, cls_menu_item_box] },
        React.createElement(HBox, { className: [cls_submenu_icon_box, useif(selected, cls_selected_subitem_icon_box)] }),
        React.createElement(HBox, { className: [cls_p5r, cls_menu_subitem_text, useif(selected, cls_menu_selected_subitem)] }, props.text));
    return props.url ? React.createElement(HBox, null,
        React.createElement(Link, { url: props.url, className: cls_link_default_no_underline, routesOutOfThisWeb: props.routesOutOfThisWeb, onClickIfLocal: actions.hideMenu }, link_content)) : React.createElement(HBox, { className: cls_link_default_no_underline }, link_content);
};
var CollapsibleMenuItem = function (props) {
    var _a = React.useState(false), open = _a[0], setOpen = _a[1];
    var ChildrenArray = React.Children.toArray(props.children);
    var location = useLocation()[0];
    React.useEffect(function () {
        if (props.childrenPaths) {
            props.childrenPaths.forEach(function (value) {
                if (location.includes(value)) {
                    setOpen(true);
                }
            });
        }
    }, [location]);
    return (React.createElement(Collapsible, { open: open, onOpenChange: setOpen, className: cls_menu_item_container },
        React.createElement(CollapsibleTrigger, { asChild: true },
            React.createElement("div", null,
                React.createElement(HBox, null, ChildrenArray[0]))),
        React.createElement(CollapsibleContent, null,
            React.createElement(HBox, { className: cls_menu_gap }),
            ChildrenArray.slice(1))));
};
var MenuDivider = function () {
    return React.createElement(HBox, { className: cls_menu_item_divider_container },
        React.createElement(HBox, { className: cls_menu_item_divider }));
};
var PageMenu = function (props) {
    var state = useResponsivity()[0];
    var T_MOB = state.thresholdMenuOnButton;
    var HideMenu = T_MOB && !state.showMenu;
    React.useEffect(function () {
        if (state.showMenu) {
            window.scrollTo(0, 0);
        }
    }, [state.showMenu]);
    var cls = [
        cls_menu_box,
        useif(T_MOB, cls_menu_box_mobile),
        useif(HideMenu, cls_menu_or_content_box_mobile_hidden),
    ];
    return React.createElement(VBox, { className: cls }, props.children);
};
export { MenuItem, MenuSubItem, CollapsibleMenuItem, MenuDivider, PageMenu, };
